export default __webpack_public_path__ + "static/media/switch_class_icon.7582f7a6.svg";